var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('picture', {
    key: _vm.nSources[0].src
  }, [_vm.nSources[1] ? _c('source', {
    attrs: {
      "type": _vm.nSources[1].type,
      "srcset": _vm.nSources[1].srcset,
      "sizes": _vm.nSources[1].sizes
    }
  }) : _vm._e(), _vm._v(" "), _c('img', _vm._g(_vm._b({
    attrs: {
      "src": _vm.nSources[0].src,
      "srcset": _vm.nSources[0].srcset,
      "sizes": _vm.nSources[0].sizes
    }
  }, 'img', Object.assign({}, _vm.nImgAttrs, _vm.imgAttrs), false), _vm.$listeners))]);

}
var staticRenderFns = []

export { render, staticRenderFns }